

function getBrowser() {
    //获取地址栏参数
    if(!navigator){
        return {}
    }
    var u = navigator.userAgent;
    return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Firefox') > -1, //火狐内核Gecko
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android
        iPhone: u.indexOf('iPhone') > -1, //iPhone
        iPad: u.indexOf('iPad') > -1, //iPad
        webApp: u.indexOf('Safari') > -1, //Safari
        user: u,
    };
}

export function getQueryString(name, type) {
    //获取地址栏参数
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var search = window.location.search;
    if (type) {
        search = decodeURI(search);
    }
    var r = search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
export function isWtsApp() {
    //微信
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/wtsbxwApp/i) == 'wtsbxwapp' ? true : false;
}

export function isWtsNativeApp() {
    //微信
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/wtsApp/i) == 'wtsapp' ? true : false;
}
export function isIOS() {
    //微信
    var ua = getBrowser().ios || getBrowser().iPad || getBrowser().iPhone
    return ua;
}
export function isMobile() {
    //微信
    var ua = getBrowser().mobile;
    return ua;
}
export function isWeiXin() {
    //微信
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger' ? true : false;
}

export function isWeiXinWork() {
    //企业微信
    var ua = getBrowser().user.toLowerCase();
    if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
        return true;
    }
    return false;
}


export function isAL() {
    //支付宝环境
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/Alipay/i) == 'alipay' ? true : false;
}


export function isBaidu() {
    //百度app环境
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/Baiduboxapp/i) == 'baiduboxapp' ? true : false;
}


export function isTouTiao() {
    //今日头条环境
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/Newsarticle/i) == 'newsarticle' ? true : false;
}


export function isDouYin() {
    //抖音环境
    var ua = getBrowser().user.toLowerCase();
    return ua.match(/Aweme/i) == 'aweme' ? true : false;
}


export function isDD() {
    //钉钉环境
    var ua = getBrowser().user.toLowerCase();
    return ua.indexOf('dingtalk') >= 0 ? true : false;
}

export function isIphonex() {
    //iphonex环境
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
        if (screen.height == 812 && screen.width == 375) {
            return true;
        }
        else {
            return false;
        }
    }
}


export function getAnbanben() {
    //获取安卓版本号
    var user = getBrowser().user;
    var index = user.indexOf('Android');
    if (index > 0) {
        return parseFloat(user.slice(index + 8));
    } else {
        return null;
    }
}

export function delQueStr(url, ref) {
    //删除地址栏参数
    var str = "";
    if (url.indexOf('?') != -1) {
        str = url.substr(url.indexOf('?') + 1);
    } else {
        return url;
    }
    var arr = "";
    var returnurl = "";
    if (str.indexOf('&') != -1) {
        arr = str.split('&');
        for (var i in arr) {
            if (arr[i].split('=')[0] != ref) {
                returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
            }
        }
        return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1) + hasHash();
    } else {
        arr = str.split('=');
        if (arr[0] == ref) {
            return url.substr(0, url.indexOf('?')) + hasHash();
        } else {
            return url;
        }
    }
}
//获取当前hash值
function hasHash() {
    if (window.location.hash && window.location.hash.length > 0) {
        if (isAL() && window.location.hash.split("?").length > 1) {
            return "";
        }
        return window.location.hash;
    }
    return "";
}


export function getcookie(name) {
    //获取cookie
    var strcookie = document.cookie;
    var arrcookie = strcookie.split('; ');
    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split('=');
        if (arr[0] == name) return decodeURIComponent(arr[1]);
    }
    return '';
}
export function setcookie(key, val, params) {
    //设置cookie
    var param = '';
    if(params){
        for (var k in params) {
            param += '' + k + '=' + params[k] + ';';
        }
        if(!params || !params.expires){
            var d = new Date();
            d.setTime(d.getTime() + (1000 * 60 * 60 * 24 * 30));
            d=d.toGMTString();
            param += 'expires==' + d + ';';
        }
    }
    document.cookie = key + "=" + escape(val) + ";"+param;
}


export function setLocal(name, value, type) {
    //设置本地储存
    var curTime = new Date().getTime();
    if (!type || type == 2) {
        //默认设置-之前存在则使用创建时间
        var data = localStorage.getItem(name);
        if (!data || data == 'null') {
            localStorage.setItem(
                name,
                JSON.stringify({
                    data: value,
                    time: curTime,
                })
            );
        } else {
            var dataObj = JSON.parse(data);
            var setTime = dataObj.time;
            localStorage.setItem(
                name,
                JSON.stringify({
                    data: value,
                    time: setTime,
                })
            );
        }
    } else if (type == 1) {
        //type:1重新创建
        localStorage.setItem(
            name,
            JSON.stringify({
                data: value,
                time: curTime,
            })
        );
    }
}

export function getLocal(name, exp) {
    //获取本地储存
    var data = localStorage.getItem(name);
    var dataObj = JSON.parse(data);
    if (!exp) {
        var exp = 1000 * 60 * 60 * 24 * 3;
    }
    if (dataObj && new Date().getTime() - dataObj.time > exp) {
        localStorage.removeItem(name);
        console.log('信息已过期');
        return null;
    } else {
        var dataObjDatatoJson = !dataObj ? null : dataObj.data;
        return dataObjDatatoJson;
    }
}

export function getDateSex() {
    //获取身份证对应的性别和年龄
    var UUserCard = num;
    var returns = {
        age: '',
        sex: ''
    };
    //获取出生日期
    UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
    //获取性别
    if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
        returns.sex = 1;
    } else {
        returns.sex = 2;
    }
    //获取年龄
    var myDate = new Date();
    var month = myDate.getMonth() + 1;
    var day = myDate.getDate();
    var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
    if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
        age++;
    }
    returns.age = age;
    return returns;
}


export function cutString(content, length) {
    //截取字符串  根据字符是否为圆角字符来记数
    var _ret = getCutValue(content, length);
    var _cutFlag = _ret.cutflag;
    var _cutStringn = _ret.cutstring;
    if (_cutFlag) {
        return _cutStringn + '...';
    } else {
        return _cutStringn;
    }
}

function getCutValue(pStr, pLen) {
    // 原字符串长度
    var _strLen = pStr.length;
    var _cutString;
    // 默认情况下，返回的字符串是原字符串的一部分
    var _cutFlag = true;
    var _lenCount = 0;
    var _ret = false;

    if (_strLen <= pLen / 2) {
        _cutString = pStr;
        _ret = true;
    }
    if (!_ret) {
        for (var i = 0; i < _strLen; i++) {
            if (isFull(pStr.charAt(i))) {
                _lenCount += 2;
            } else {
                _lenCount += 1;
            }
            if (_lenCount > pLen) {
                _cutString = pStr.substring(0, i);
                _ret = true;
                break;
            } else if (_lenCount == pLen) {
                _cutString = pStr.substring(0, i + 1);
                _ret = true;
                break;
            }
        }
    }
    if (!_ret) {
        _cutString = pStr;
        _ret = true;
    }

    if (_cutString.length == _strLen) {
        _cutFlag = false;
    }
    return {
        cutstring: _cutString,
        cutflag: _cutFlag
    };
}

function isFull(pChar) {
    //是否全角文字
    if (pChar.charCodeAt(0) > 128) {
        return true;
    } else {
        return false;
    }
}

export function randomRangeId(num) {
    // 生产随机id
    var returnStr = "",
        charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < num; i++) {
        var index = Math.round(Math.random() * (charStr.length - 1));
        returnStr += charStr.substring(index, index + 1);
    }
    return returnStr;
}
export function trim(val) {
    // 过滤空格
    return val.replace(/(^\s*)|(\s*$)/g, '');
}
export function isArray(o) {
    // 判断是数组
    return Object.prototype.toString.call(o) == '[object Array]';
}
export function addCss(css) {
    var D = document, _s = D.createElement('style');
    _s.setAttribute("type", "text/css");
    _s.styleSheet && (_s.styleSheet.cssText = css) ||
        _s.appendChild(D.createTextNode(css));
    D.getElementsByTagName('head')[0].appendChild(_s);
}
export function loadScript(url, callback) {
     // 传入url , 和要执行的回调函数
     const script = document.createElement('script');
     script.type = 'text/javascript';
     // 创建一个script标签
     if (script.readyState) {
        // 做兼容
        script.onreadystatechange = function() {
            // readyState变化触发
            if (script.readyState === 'complete' || script.readyState === 'loaded') {
                callback();  // 加载完执行回调
            }
        }
    } else {
        script.onload = function() {
            callback();  // 加载完执行回调
        }
    }
    var href=url.indexOf('?')>-1?url+="&v="+randomRangeId(6):url+="?v="+randomRangeId(6)
    script.src = href;
    document.head.appendChild(script);  // 插入head中
}
